/*
  Appstle-Bundles (Mix Dein Set): Bestandteile mit dem Set entfernen.

  Appstle legt ein Set als Set-Zeile (__appstle-bb-variants) plus Bestandteile (_appstle-bb-child,
  z. B. Sorten + Gratis-Bottle) in den Warenkorb; die Bestandteile kosten nur zusammen mit dem Set 0 €.
  Wird die Set-Zeile entfernt, blieben die Bestandteile sonst zum vollen Preis im Warenkorb liegen
  (4 Sorten + Bottle = 79,75 €). Dieses Script entfernt sie in dem Fall automatisch.

  Läuft nach jeder Warenkorb-Änderung (Theme-Event cart:change, außer beim Hinzufügen) und beim
  Seitenaufruf. Bestandteile, deren Set noch im Warenkorb liegt, bleiben unangetastet.

  Außerdem: Appstle schickt die Sortenliste des Sets als Eigenschaft "products" mit – die erscheint
  so im Warenkorb und im Checkout. Vor dem Absenden wird sie in "Produkte" umbenannt (fetch-Wrapper
  für cart/add, nur JSON-Bodies; alles andere geht unverändert durch).
  Eingebunden in layout/theme.liquid.
*/
(function () {
  var renameProducts = function (body) {
    if (typeof body !== 'string' || body.indexOf('"products"') === -1) return body;
    try {
      var data = JSON.parse(body);
      var list = Array.isArray(data.items) ? data.items : [data];
      var changed = false;
      list.forEach(function (item) {
        var p = item && item.properties;
        if (p && Object.prototype.hasOwnProperty.call(p, 'products') && !p.Produkte) {
          p.Produkte = p.products;
          delete p.products;
          changed = true;
        }
      });
      return changed ? JSON.stringify(data) : body;
    } catch (e) {
      return body;
    }
  };
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (init && /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''))) {
        var body = renameProducts(init.body);
        if (body !== init.body) init = Object.assign({}, init, { body: body });
      }
    } catch (e) {}
    return originalFetch.call(this, input, init);
  };
})();

(function () {
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  var orphanUpdates = function (cart) {
    var parents = {};
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      if (p['__appstle-bb-variants'] && p['_appstle-bb-id']) parents[p['_appstle-bb-id']] = true;
    });
    var updates = {};
    var count = 0;
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      if (p['_appstle-bb-child'] === 'true' && !parents[p['_appstle-bb-id']]) {
        updates[item.key] = 0;
        count += 1;
      }
    });
    return count ? updates : null;
  };

  var cleanup = async function (cart) {
    if (busy) return;
    busy = true;
    try {
      if (!cart) cart = await (await fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var updates = orphanUpdates(cart);
      if (!updates) return;
      var response = await fetch(cartRoot + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      if (!response.ok) return;
      // Warenkorb-Seite rendert serverseitig -> einmal neu laden, damit Summe & Zeilen stimmen
      if (/\/cart\/?$/.test(location.pathname)) {
        location.reload();
        return;
      }
      // Drawer, Zähler & Co. neu laden lassen
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {
    } finally {
      busy = false;
    }
  };

  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    // Beim Hinzufügen nichts tun: Set und Bestandteile kommen dort gemeinsam in einem Request
    if (detail.baseEvent === 'variant:add') return;
    cleanup(detail.cart && detail.cart.items ? detail.cart : null);
  });

  var start = function () { cleanup(null); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
